import { UserRole } from 'types';

import {
  FAKTUROWNIA_ACCESS_ROLES,
  HOMEWORK_ERP_ROLES,
  MANAGEMENT_ROLES,
  PANDADOC_ACCESS_ROLES,
  TEACHER_INSIGHT_ROLES,
} from './groupCardRoles';

/**
 * Карточка студента (`/students/:id/details`) — кто какой её запрос и какое
 * поле ЧИТАЕТ на бэкенде. Маршрут к карточке (`STUDENT_CARD_ROLES`: Admin,
 * AccountManager, SalesManager, FinanceManager, Methodist) шире почти любого из
 * этих списков. Решение владельца 07.10.2026: методисту карточка «про учёбу» —
 * имя, группы, опросы, ДЗ, посещаемость и оценки; что роль не читает, прячем,
 * а запрос не шлём (как у карточки группы, `groupCardRoles`).
 *
 * Каждый список — зеркало ОДНОЙ константы бэкенда (`tmsis_py_server/tmsis/…`);
 * совпадающий по смыслу список приложения берём как есть, а не копируем.
 */

/**
 * `erp_management_viewer` (`core/permissions.py`) = `settings.MANAGEMENT_ROLES`
 * — поля `StudentType`, закрытые классом данных: договоры (`agreements`, с ними
 * взносы, платежи, PandaDoc договора), итоги (`totals`), долги
 * (`accountsPayables`), служебная лента (`timeline`), контакты
 * (`CustomUserType.email/phone`), Slack, заметки, переписка. Вне списка
 * приходят пустыми (`[]` / `null` / `''`), а не ошибкой — блок, нарисованный
 * по ним, соврал бы «долгов нет», «контактов нет». Группы студента всем
 * ролям карточки отдаёт `educationGroups` (`erp_education_viewer`: управленцы
 * и методист).
 */
export const STUDENT_STAFF_FIELDS_ROLES: UserRole[] = MANAGEMENT_ROLES;

/** `FAKTUROWNIA_ACCESS_ROLES` (`fakturownia/schema/schema.py`) — `fakturowniaInvoices`, проформы. */
export const STUDENT_INVOICES_ROLES: UserRole[] = FAKTUROWNIA_ACCESS_ROLES;

/**
 * «Привязать счёт» к взносу — `linkInvoiceToContribution`, роли
 * `FAKTUROWNIA_ACCESS_ROLES` бэкенда (Admin, Finance, Sales, AM). Одна
 * константа на кнопку шапки карточки и на «Привязать к взносу» в таблицах
 * счетов (перепроверка E1-3): шапка гейтилась `canRecordPayment` (без
 * продаж), строка таблицы — никак, и две кнопки одного действия видели
 * разные роли.
 */
export const INVOICE_LINK_ROLES: UserRole[] = FAKTUROWNIA_ACCESS_ROLES;

/** `PANDADOC_ACCESS_ROLES` (`pandadoc/schema/schema.py`) — вкладка «Документы на подпись». */
export const STUDENT_PANDADOC_ROLES: UserRole[] = PANDADOC_ACCESS_ROLES;

/**
 * `HOMEWORK_ERP_ROLES` (`homeworks/schema/schema.py`) — `studentHomeworkForErp`:
 * Admin, AccountManager, Methodist. Продажам и финансисту вкладка «ДЗ» не
 * рисуется: сервер отказывал, и вкладка существовала, чтобы сказать «ошибка».
 */
export const STUDENT_HOMEWORK_ROLES: UserRole[] = HOMEWORK_ERP_ROLES;

/**
 * `SURVEY_INSIGHT_READ_ROLES` (= `TEACHER_INSIGHT_ROLES`,
 * `surveys/schema/schema.py`) — `studentSurveyResponses`: менеджеры опросов
 * (Admin, AccountManager, Methodist) и HR.
 */
export const STUDENT_SURVEY_RESPONSES_ROLES: UserRole[] = TEACHER_INSIGHT_ROLES;
